import { render, staticRenderFns } from "./SelfEvaluationTable.vue?vue&type=template&id=62275c3c&scoped=true"
import script from "./SelfEvaluationTable.vue?vue&type=script&lang=js"
export * from "./SelfEvaluationTable.vue?vue&type=script&lang=js"
import style0 from "./SelfEvaluationTable.vue?vue&type=style&index=0&id=62275c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62275c3c",
  null
  
)

export default component.exports